import { PostResponse } from '../types/common.types';
import {
	DeactivateRoutineRequest,
	MaterialRoutineExportFilter,
	MaterialRoutineMaster,
	MaterialRoutineType,
	SaveMaterialRoutineRequest,
} from '../types/routine.types';
import axiosInstance from '../utils/axios-instance';

// #region GET
export const getMaterialRoutines = async (): Promise<MaterialRoutineType[]> => {
	const url: string = `/MaterialIntegrityRoutine/GetMaterialRoutines`;
	return axiosInstance.get(url);
};

export const getMatRoutineMaster = async (): Promise<MaterialRoutineMaster> => {
	const url: string = `/MaterialIntegrityRoutine/GetMaster`;
	return axiosInstance.get(url);
};

export const exportData = async (filter: MaterialRoutineExportFilter): Promise<any> => {
	const url: string = `/MaterialIntegrityRoutine/ExportMaterialRoutine`;
	return axiosInstance.post(url, filter, { responseType: 'arraybuffer' });
};

export const getBlobSasToken = async (): Promise<string> => {
	const url: string = `/MaterialIntegrityRoutine/GetBlobSasToken`;
	return axiosInstance.get(url);
};

export const downloadFile = async (blobPath: string, fileName: string): Promise<any> => {
	const url: string = `/MaterialIntegrityRoutine/Download?blobPath=${blobPath}&fileName=${fileName}`;
	return axiosInstance.get(url, {
		responseType: 'blob',
	});
};
// #endregion

// #region POST
export const saveMaterialRoutine = async (request: SaveMaterialRoutineRequest): Promise<PostResponse> => {
	const url: string = `/MaterialIntegrityRoutine/SaveMaterialIntegrityRoutine`;
	return await axiosInstance.post(url, request);
};

export const uploadFile = async (saveRequest: FormData): Promise<PostResponse | any> => {
	const url: string = `/MaterialIntegrityRoutine/Upload`;
	return axiosInstance.post(url, saveRequest, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};
// #endregion

// #region PUT
export const stopRoutine = async (request: DeactivateRoutineRequest): Promise<PostResponse> => {
	const url: string = `/MaterialIntegrityRoutine/StopRule?ruleId=${request.ruleId}&endDate=${request.endDate}`;
	return await axiosInstance.put(url);
};
// #endregion

// #region DELETE
export const deleteFile = async (blobPath: string, fileName: string): Promise<PostResponse | any> => {
	const url: string = `/MaterialIntegrityRoutine/Delete?blobPath=${blobPath}&fileName=${fileName}`;
	return axiosInstance.delete(url);
};
// #endregion
